const messages = {
  [`main.count`]: "تعداد سفارش",
  [`customer`]: "طرف حساب ها",
  [`orders`]: "سفارشات",
  [`catalogs`]: "تعداد سفارش",
  [`catalog`]: "کاتالوگ",
  "admin.dashboard": "داشبورد مدیریت",
  province: "استان",
  city: "شهرستان",
  region: "منطقه",
  district: "محله",
  district: "محله",
  GeographicalRegion: "موقعیت جغرافیایی",
  "apply.filter": "محدودسازی",
  description: "توضیحات",
  view: "مشاهده",
  cancel: "انصراف",
  close: "خروج",
};

export default messages;
